import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { of, Subject, Subscription } from 'rxjs';
import { delay, finalize, takeUntil, tap } from 'rxjs/operators';

import { SendTypes } from 'src/app/core/api/models';
import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { AuthTokenService } from 'src/app/core/services/authentication/auth-token.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { AppMobilesAnalysisSelectedMode } from 'src/app/core/types/app-mobiles-analysis-selected-mode.type';
import {
  DialogService,
  DialogStatus,
} from '../../../../core/services/dialog.service';
import { FileService } from '../../../../core/services/file.service';
import { MobileNumbersService } from '../../../../core/services/mobile-numbers.service';
import { UtilityService } from '../../../../core/services/utility.service';

//compress text method
declare function compressToEncodedURIComponent(input): any;

@Component({
    selector: 'app-base-mobiles-analysis',
    template: ``,
    standalone: false
})
export class BaseMobilesAnalysisComponent {
  @Input('uniqId') input_id: string;
  @Input('isTwilioNumber') input_isTwilioNumber: boolean = false;
  public cd = inject(ChangeDetectorRef);
  pastedLoading: boolean = false;
  protected onDestroy$ = new Subject<void>();

  pastedSubscription: Subscription;

  //final mobile Numbers
  mobileNumbers: string = '';

  //mobile Numbers
  mobileNumbersInManualMode: string = '';
  mobileNumbersInUploadFileMode: string = '';
  mobileNumbersInClipboardMode: string = '';
  //wrong Mobile Numbers
  wrongMobileNumbersInManualMode: string = '';
  wrongMobileNumbersInUploadFileMode: string = '';
  wrongMobileNumbersInClipboardMode: string = '';
  //mobile Numbers count
  mobileNumbersCountInManualMode: number = 0;
  mobileNumbersCountInUploadFileMode: number = 0;
  mobileNumbersCountInClipboardMode: number = 0;
  //wrong Mobile Numbers count
  wrongMobileNumbersCountInManualMode: number = 0;
  wrongMobileNumbersCountInUploadFileMode: number = 0;
  wrongMobileNumbersCountInClipboardMode: number = 0;
  //duplicated Mobile Numbers count
  duplicatedMobileNumbersCountInManualMode: number = 0;
  duplicatedMobileNumbersCountInUploadFileMode: number = 0;
  duplicatedMobileNumbersCountInClipboardMode: number = 0;
  //mobile Numbers File
  mobileNumbersFileInManualMode: string = '';
  mobileNumbersFileInClipboardMode: string = '';
  //wrong Mobile Numbers File
  wrongMobileNumbersFileInManualMode: string = '';
  wrongMobileNumbersFileInClipboardMode: string = '';
  wrongMobileNumbersFileInUploadFileMode: string = '';

  @Input() isCompressionMobiles: boolean = true;

  @Output('mobileNumbers') outputModel = new EventEmitter<string>();

  wrongMobileNumbers: string = '';
  textAreaValueStored: string = '';

  alertDialog: boolean = false;

  //#region Count

  @Input('maxMobileNumbers') maxMobileNumbers = 1000000;
  @Input('maxMobileNumbersInManualMode') maxMobileNumbersInManualMode = 10000;
  @Input('maxMobileNumbersInClipBoardMode')
  maxMobileNumbersInClipBoardMode = 1000000;
  //#endregion

  //#region Download File

  wrongMobileNumbersFile: string = '';
  fileUrlWrongMobileNumbers = '';
  fileUrlCorrectMobileNumbers = '';
  countOfCorrectMobileNumber: number = 0;
  countOfWrongMobileNumber: number = 0;

  //link id
  linkIdCorrectMobileNumbers = 'linkIdCorrectMobileNumbers';
  linkIdWrongMobileNumbers = 'linkIdWrongMobileNumbers';

  //#endregion

  //#region Pasted Text
  file: any;
  maxPastedTextSize: number = 15; //MB
  maxPastedTextSizeInManualMode: number = 1; //MB
  maxLenDisplay: number = 80000000;
  maxLenDisplayInClipboardMode: number = 3;
  //#endregion

  //#region file
  @Input('maxFileSize') maxFileSize: number = 15; //mb
  fileTypes: string[] = ['txt', 'xls', 'xlsx', 'csv'];
  excelTypes: string[] = ['xls', 'xlsx', 'csv'];

  @Input('uploadFileToServer') uploadFileToServer: boolean = false;
  @Input('isInquireBlackList') isInquireBlackList: boolean = false;
  @Input('action') action: string =
    AppConfigService.config.apiUrl + '/ScheduledMessages/UploadFile';

  filePath = '';
  progress: number;

  @Output('filePath') outputFilePath = new EventEmitter<string>();
  @Output('inquireBlackListFile') outputInquireBlackListFile =
    new EventEmitter<any>();
  @Output('selectedMode') outputSelectedMode =
    new EventEmitter<AppMobilesAnalysisSelectedMode>();
  @Output('isNeedUserConfirmation') output_isNeedUserConfirmation =
    new EventEmitter<boolean>();

  //#endregion

  // Alert
  alertMessage: string;
  confirmMessage: boolean = true;

  selectedMode: AppMobilesAnalysisSelectedMode = 'manual';

  //#endregion

  constructor(
    protected mobileNumbersService: MobileNumbersService,
    protected sanitizer: DomSanitizer,
    protected dialogService: DialogService,
    protected translate: TranslateService,
    protected UtilityService: UtilityService,
    protected fileService: FileService,
    protected numberSeparatorPipe: NumberSeparatorPipe,
    protected http: HttpClient,
    protected apiNotificationService: ApiNotificationService,
    protected renderer: Renderer2
  ) {}

  //#region Checking Methods

  checkInputText(event) {
    let inputText = (event.target as HTMLInputElement).value;
    if (this.textAreaValueStored === this.mobileNumbersInManualMode.trim())
      return;

    if (event) if (event?.key !== 'Enter' && event?.type != 'change') return;

    inputText = this.UtilityService.getTextWithEnglishNumber(inputText);
    this.checkMobileNumbers(inputText);
  }

  checkPastedText(event, inputPastedText?: any) {
    if (inputPastedText) {
      //چک کردن سایز متن
      if (
        !this.checkTextSizeIsValid(
          inputPastedText,
          this.selectedMode == 'manual'
            ? this.maxPastedTextSizeInManualMode
            : this.maxPastedTextSize,
          this.selectedMode == 'manual'
        )
      )
        return;

      //چک میکنه قبلا شماره ای وارد شده
      if (this.mobileNumbersInClipboardMode) {
        inputPastedText =
          this.mobileNumbersInClipboardMode.replace(/,/g, '\n') +
          '\n' +
          inputPastedText;
        this.clearCorrectMobileNumbers();
      }
      inputPastedText =
        this.UtilityService.getTextWithEnglishNumber(inputPastedText);
      this.checkMobileNumbers(inputPastedText, true);

      return;
    }

    const clipboardTextareaElement = document.getElementById(
      this.input_id + '-clipboard-textarea'
    ) as HTMLTextAreaElement;

    event?.preventDefault();

    // آنساب اسکرایب می کنه قبلی ها را برای هدر نرفتن سرعت و منابع
    if (this.pastedSubscription) this.pastedSubscription.unsubscribe();

    //دادها ها را بصورت آبزرویبل میگیره
    of(event.clipboardData.getData('text'))
      .pipe(
        tap(() => (this.pastedLoading = true)),
        takeUntil(this.onDestroy$),
        delay(200), //delay
        finalize(() => (this.pastedLoading = false))
      )
      .subscribe((pastedText) => {
        this.pastedLoading = false;
        const timeOut = setTimeout(() => {
          this.renderer.setProperty(clipboardTextareaElement, 'value', '');

          // clipboardTextareaElement.value = '';
          clearTimeout(timeOut);
        }, 200);

        //چک کردن سایز متن
        if (
          !this.checkTextSizeIsValid(
            pastedText,
            this.selectedMode == 'manual'
              ? this.maxPastedTextSizeInManualMode
              : this.maxPastedTextSize,
            this.selectedMode == 'manual'
          )
        )
          return;

        //چک میکنه قبلا شماره ای وارد شده
        if (
          this.selectedMode == 'clipboard' &&
          this.mobileNumbersInClipboardMode
        ) {
          pastedText =
            this.mobileNumbersInClipboardMode.replace(/,/g, '\n') +
            '\n' +
            pastedText;

          this.clearCorrectMobileNumbers();
        } else if (
          this.selectedMode == 'manual' &&
          this.mobileNumbersInManualMode
        ) {
          pastedText =
            this.mobileNumbersInManualMode.replace(/,/g, '\n') +
            '\n' +
            pastedText;
          this.clearCorrectMobileNumbers();
        }
        if (pastedText) {
          pastedText = this.UtilityService.getTextWithEnglishNumber(pastedText);
          if (this.selectedMode == 'manual')
            this.checkMobileNumbers(pastedText, false);
          else this.checkMobileNumbers(pastedText, true);
        }
      });
  }

  checkTextSizeIsValid(text, maxTextSize, isManualMode?: boolean): boolean {
    let textSize = +text.getSizeOfMB().toFixed(1);

    if (textSize > maxTextSize) {
      let message = '';

      if (isManualMode)
        message = this.translate.instant('messages.textMaxLengthInManualMode', {
          size: maxTextSize,
        });
      else
        message = this.translate.instant('messages.textMaxLength', {
          size: maxTextSize,
        });

      this.dialogService.openDialog({
        title: 'common.error',
        message: message,
        status: DialogStatus.error,
      });
      return false;
    }
    return true;
  }

  checkCountOfCorrectMobileNumberIsValid(): boolean {
    if (
      this.selectedMode != 'manual' &&
      this.countOfCorrectMobileNumber >= this.maxLenDisplay
    )
      return false;

    return true;
  }

  checkMobileNumbers(text: string, appendToPrevious?: boolean) {
    text = text.trim().replace(/,|،/g, '\n');

    //trim the text line by line
    text = text
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line)
      .join('\n');

    //گرفتن شماره موبایل های  صحیح از متن ورودی
    let correctMobileNumberArray: string[] =
      this.mobileNumbersService.getCorrectMobileNumbersFromText(
        text,
        this.input_isTwilioNumber
      );

    //چک کردن مجاز بودن تعداد شماره موبایل های صحیح
    correctMobileNumberArray = this.checkMaxCountOfMobileNumbers(
      correctMobileNumberArray
    );

    //تعداد شماره موبایل های صحیح را ثبت می کنه
    this.setCountOfCorrectMobileNumber(
      correctMobileNumberArray,
      appendToPrevious
    );

    //گرفتن شماره موبایل های اشتباه
    let wrongMobileNumberArray: string[] =
      this.mobileNumbersService.getWrongMobileNumbersFromText(
        text,
        this.input_isTwilioNumber
      );

    //تعداد شماره موبایل های اشتباه را ثبت می کنه
    this.setCountOfWrongMobileNumber(wrongMobileNumberArray, true);

    //ثبت کردن مدل نهایی
    this.setFinalModel(correctMobileNumberArray, appendToPrevious);

    //ساختن فایلهای تکست شماره موبایل های صحیح
    this.createMobileNumbersFile();

    //نمایش در تکست ایریا مربوط به حالت دستی
    if (this.selectedMode == 'manual') this.displayCorrectMobileNumbers();

    //نمایش خطاها
    this.displayWrongMobileNumbers(wrongMobileNumberArray, true);

    //ساختن فایلهای تکست شماره موبایل های اشتباه
    this.createWrongMobileNumbersFile();
  }

  //#endregion

  //#region upload file

  checkFile(file) {
    if (!this.uploadFileToServer && !this.isInquireBlackList) {
      if (file == null || file == undefined) {
        this.clearCorrectMobileNumbers();
        return;
      }

      // let file = event.target.files[0];

      if (!this.checkFileType(file, this.fileTypes)) {
        this.resetInputFile();
        return;
      }
      if (!this.checkFileSize(file, this.maxFileSize)) {
        this.resetInputFile();
        return;
      }

      let fileType = this.fileService.getFileType(file);

      if (this.excelTypes.indexOf(fileType) > -1) this.readExcelFile(file);
      else if (fileType === 'txt') this.readTxtFile(file);
    } else if (this.uploadFileToServer && this.isInquireBlackList) {
      this.outputInquireBlackListFile.emit(file);
    } else {
      this.uploadFile(file);
    }
  }

  uploadFile(file) {
    if (this.uploadFileToServer) {
      try {
        if (file == null || file == undefined) {
          this.outputFilePath.emit(file);
          return;
        }

        this.progress = 1;
        let formData: any = new FormData();
        let fileToUpload = <File>file;

        formData.append(
          'file',
          fileToUpload,
          fileToUpload.name.replace(/\s/g, '')
        );
        formData.append('sendTypes', SendTypes.Single);

        const headers = new HttpHeaders()
          .set('Accept', 'application/json')
          .set('enctype', 'multipart/form-data')
          .set('ngsw-bypass', 'true')
          .set('Authorization', 'Bearer ' + AuthTokenService.getAccessToken());

        this.http
          .post(this.action, formData, {
            headers: headers,
            reportProgress: true,
            observe: 'events',
          })
          .pipe(
            takeUntil(this.onDestroy$),
            tap((event: any) => {
              if (event.type == HttpEventType.UploadProgress) {
                ConsoleService.info('loaded', event.loaded);
                ConsoleService.info('loaded', event.total);
                this.progress = Math.round((100 / event.total) * event.loaded);
              } else if (event.type == HttpEventType.Response) {
                this.progress = null;
              }
            })
          )
          .subscribe(async (result) => {
            if (result.body) {
              result = result.body;
              this.apiNotificationService.notifyMessage({ result });
              if (result.isSucceed) {
                let data = JSON.parse(result?.data);
                this.filePath = data.path;

                this.outputFilePath.emit(
                  AppConfigService.config.apiUrl + '/' + this.filePath
                );
              }
            }
          });
      } catch (error) {
        ConsoleService.error('error', error);
      }
    }
  }

  checkIsNullFile(event) {
    this.clearCorrectMobileNumbers();
  }

  checkFileType(file, fileTypes): boolean {
    if (this.fileService.checkFileType(file, fileTypes)) return true;
    return false;
  }

  checkFileSize(file, maxSize): boolean {
    if (this.fileService.checkFileSizeWithMb(file, maxSize)) return true;
    return false;
  }

  readExcelFile(file) {
    this.pastedLoading = true;
    // read file
    this.fileService
      .readExcelFile(file)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.pastedLoading = false))
      )
      .subscribe((data) => {
        //clear textarea
        this.clearCorrectMobileNumbers();

        let values: any[] = [];
        let text: string;

        if (data.jsonData.length > 0)
          data.jsonData.forEach((item) => {
            Object.values(item).forEach((value) => {
              values.push(value);
            });
          });

        text = values?.join('\n');
        if (text) {
          text = this.UtilityService.getTextWithEnglishNumber(text);
          this.checkMobileNumbers(text, true);
          this.showAlertDialog();
          this.cd.detectChanges();
        }
      });
  }

  readTxtFile(file) {
    this.pastedLoading = true;
    // read file
    this.fileService
      .readTxtFile(file)
      .pipe(
        tap((text) => {
          this.clearCorrectMobileNumbers();
          //check mobile numbers
          if (text) {
            text = this.UtilityService.getTextWithEnglishNumber(text);
            this.checkMobileNumbers(text, true);
            this.showAlertDialog();
            this.cd.detectChanges();
          }
          return text;
        }),
        takeUntil(this.onDestroy$),
        finalize(() => (this.pastedLoading = false))
      )
      .subscribe();
  }

  resetInputFile() {
    const deleteBtn = document.getElementById(this.input_id + '-delete-btn');
    deleteBtn.click();
    this.clearCorrectMobileNumbers();
  }

  //#endregion

  //#region Create & Download File

  createMobileNumbersFile() {
    if (
      this.selectedMode == 'manual' &&
      this.mobileNumbersCountInManualMode > 0
    )
      this.mobileNumbersFileInManualMode = this.createTextFile(
        this.mobileNumbersInManualMode.replace(/,/g, ',\n')
      );
    else if (
      this.selectedMode == 'clipboard' &&
      this.mobileNumbersCountInClipboardMode > 0
    )
      this.mobileNumbersFileInClipboardMode = this.createTextFile(
        this.mobileNumbersInClipboardMode.replace(/,/g, ',\n')
      );
  }

  createWrongMobileNumbersFile() {
    if (
      this.selectedMode == 'manual' &&
      this.wrongMobileNumbersCountInManualMode > 0
    )
      this.wrongMobileNumbersFileInManualMode = this.createTextFile(
        this.wrongMobileNumbersInManualMode.replace(/,/g, ',\n')
      );
    else if (
      this.selectedMode == 'clipboard' &&
      this.wrongMobileNumbersCountInClipboardMode > 0
    )
      this.wrongMobileNumbersFileInClipboardMode = this.createTextFile(
        this.wrongMobileNumbersInClipboardMode.replace(/,/g, ',\n')
      );
    else if (
      this.selectedMode == 'uploadFile' &&
      this.wrongMobileNumbersCountInUploadFileMode > 0
    )
      this.wrongMobileNumbersFileInUploadFileMode = this.createTextFile(
        this.wrongMobileNumbersInUploadFileMode.replace(/,/g, ',\n')
      );
  }

  createTextFile(data): any {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    let fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    return fileUrl;
  }

  downloadMobileNumbersExcelFile() {
    let array;
    let mobileNumbers: string;

    if (this.selectedMode == 'manual')
      mobileNumbers = this.mobileNumbersInManualMode;
    else if (this.selectedMode == 'clipboard')
      mobileNumbers = this.mobileNumbersInClipboardMode;

    mobileNumbers = mobileNumbers.replace(/,/g, '\n');
    array = mobileNumbers.split('\n');

    let excelFileData = array.map((item) => {
      return { '': item.toString() };
    });

    // this.excelService.exportAsExcelFile(excelFileData, 'pageExcelReport');
    this.fileService.exportAsExcelFile(excelFileData, 'pageExcelReport');
  }

  downloadWrongMobileNumbersExcelFile() {
    let array;
    let wrongMobileNumbers: string;

    if (this.selectedMode == 'manual')
      wrongMobileNumbers = this.wrongMobileNumbersInManualMode;
    else if (this.selectedMode == 'clipboard')
      wrongMobileNumbers = this.wrongMobileNumbersInClipboardMode;
    else if (this.selectedMode == 'uploadFile')
      wrongMobileNumbers = this.wrongMobileNumbersInUploadFileMode;

    wrongMobileNumbers = wrongMobileNumbers.replace(/,/g, ',\n');
    array = wrongMobileNumbers.split('\n');

    let excelFileData = array.map((item) => {
      return { '': item.toString() };
    });

    // this.excelService.exportAsExcelFile(excelFileData, 'pageExcelReport');
    this.fileService.exportAsExcelFile(excelFileData, 'pageExcelReport');
  }

  //#endregion

  //#region Displayer

  displayCorrectMobileNumbers() {
    this.mobileNumbersInManualMode = this.mobileNumbersInManualMode
      .replace(/,/g, '\n')
      .trim();
    this.textAreaValueStored = this.mobileNumbersInManualMode;
  }

  displayWrongMobileNumbers(
    mobileNumberArray: string[],
    appendToPrevious?: boolean
  ) {
    if (!mobileNumberArray || mobileNumberArray?.length === 0) return;

    if (appendToPrevious) {
      if (this.selectedMode == 'manual')
        this.wrongMobileNumbersInManualMode += mobileNumberArray
          ?.toStringBetweenNewLine()
          .removeEmptyLine()
          .appendNewLine();
      else if (this.selectedMode == 'uploadFile')
        this.wrongMobileNumbersInUploadFileMode += mobileNumberArray
          ?.toStringBetweenNewLine()
          .removeEmptyLine()
          .appendNewLine();
      else if (this.selectedMode == 'clipboard')
        this.wrongMobileNumbersInClipboardMode += mobileNumberArray
          ?.toStringBetweenNewLine()
          .removeEmptyLine()
          .appendNewLine();
    } else {
      if (this.selectedMode == 'manual')
        this.wrongMobileNumbersInManualMode = mobileNumberArray
          ?.toStringBetweenNewLine()
          .removeEmptyLine()
          .appendNewLine();
      else if (this.selectedMode == 'uploadFile')
        this.wrongMobileNumbersInUploadFileMode = mobileNumberArray
          ?.toStringBetweenNewLine()
          .removeEmptyLine()
          .appendNewLine();
      else if (this.selectedMode == 'clipboard')
        this.wrongMobileNumbersInClipboardMode = mobileNumberArray
          ?.toStringBetweenNewLine()
          .removeEmptyLine()
          .appendNewLine();
    }
  }

  showAlertDialog() {
    if (this.countOfCorrectMobileNumber > this.maxLenDisplay) {
      this.alertMessage =
        this.translate.instant('components.mobilesAnalysis.alertPart1', {
          size: this.maxLenDisplay,
        }) + ' ';
      this.alertMessage += this.translate.instant('common.downloadFile') + ' ';
      this.alertMessage += this.translate.instant(
        'components.mobilesAnalysis.alertPart2'
      );
      this.dialogService.openDialog({
        title: 'common.info',
        message: this.alertMessage,
      });
    }
    this.confirmMessage = true;
  }

  //#endregion

  //#region Set Count

  setCountOfCorrectMobileNumber(
    mobileNumberArray: string[],
    appendToPrevious?: boolean
  ) {
    if (!mobileNumberArray || mobileNumberArray?.length === 0) {
      if (!appendToPrevious) {
        if (this.selectedMode == 'manual')
          this.mobileNumbersCountInManualMode = 0;
        else if (this.selectedMode == 'uploadFile')
          this.mobileNumbersCountInUploadFileMode = 0;
        else if (this.selectedMode == 'clipboard')
          this.mobileNumbersCountInClipboardMode = 0;
      }
      //     this.clearCorrectMobileNumbers();
      return;
    }
    if (appendToPrevious) {
      if (this.selectedMode == 'manual')
        this.mobileNumbersCountInManualMode += mobileNumberArray.length;
      else if (this.selectedMode == 'uploadFile')
        this.mobileNumbersCountInUploadFileMode += mobileNumberArray.length;
      else if (this.selectedMode == 'clipboard')
        this.mobileNumbersCountInClipboardMode += mobileNumberArray.length;

      return;
    }

    if (this.selectedMode == 'manual')
      this.mobileNumbersCountInManualMode = mobileNumberArray.length;
    else if (this.selectedMode == 'uploadFile')
      this.mobileNumbersCountInUploadFileMode = mobileNumberArray.length;
    else if (this.selectedMode == 'clipboard')
      this.mobileNumbersCountInClipboardMode = mobileNumberArray.length;
  }

  setCountOfDuplicatedMobileNumber(
    mobileNumberArray: string[],
    appendToPrevious?: boolean
  ) {
    if (!mobileNumberArray || mobileNumberArray?.length === 0) {
      if (!appendToPrevious) {
        if (this.selectedMode == 'manual')
          this.duplicatedMobileNumbersCountInManualMode = 0;
        else if (this.selectedMode == 'uploadFile')
          this.duplicatedMobileNumbersCountInUploadFileMode = 0;
        else if (this.selectedMode == 'clipboard')
          this.duplicatedMobileNumbersCountInClipboardMode = 0;
      }
      return;
    }

    if (appendToPrevious) {
      if (this.selectedMode == 'manual')
        this.duplicatedMobileNumbersCountInManualMode +=
          mobileNumberArray.length;
      else if (this.selectedMode == 'uploadFile')
        this.duplicatedMobileNumbersCountInUploadFileMode +=
          mobileNumberArray.length;
      else if (this.selectedMode == 'clipboard')
        this.duplicatedMobileNumbersCountInClipboardMode +=
          mobileNumberArray.length;
      return;
    }

    if (this.selectedMode == 'manual')
      this.duplicatedMobileNumbersCountInManualMode = mobileNumberArray.length;
    else if (this.selectedMode == 'uploadFile')
      this.duplicatedMobileNumbersCountInUploadFileMode =
        mobileNumberArray.length;
    else if (this.selectedMode == 'clipboard')
      this.duplicatedMobileNumbersCountInClipboardMode =
        mobileNumberArray.length;
  }

  setCountOfWrongMobileNumber(
    mobileNumberArray: string[],
    appendToPrevious?: boolean
  ) {
    if (!mobileNumberArray || mobileNumberArray?.length === 0) {
      if (!appendToPrevious) {
        if (this.selectedMode == 'manual')
          this.wrongMobileNumbersCountInManualMode = 0;
        else if (this.selectedMode == 'uploadFile')
          this.wrongMobileNumbersCountInUploadFileMode = 0;
        else if (this.selectedMode == 'clipboard')
          this.wrongMobileNumbersCountInClipboardMode = 0;
      }
      return;
      //     this.clearWrongMobileNumbers();
    }

    if (appendToPrevious) {
      if (this.selectedMode == 'manual')
        this.wrongMobileNumbersCountInManualMode += mobileNumberArray.length;
      else if (this.selectedMode == 'uploadFile')
        this.wrongMobileNumbersCountInUploadFileMode +=
          mobileNumberArray.length;
      else if (this.selectedMode == 'clipboard')
        this.wrongMobileNumbersCountInClipboardMode += mobileNumberArray.length;

      return;
    }

    if (this.selectedMode == 'manual')
      this.wrongMobileNumbersCountInManualMode = mobileNumberArray.length;
    else if (this.selectedMode == 'uploadFile')
      this.wrongMobileNumbersCountInUploadFileMode = mobileNumberArray.length;
    else if (this.selectedMode == 'clipboard')
      this.wrongMobileNumbersCountInClipboardMode = mobileNumberArray.length;
  }

  checkMaxCountOfMobileNumbers(mobileNumberArray: string[]): string[] {
    if (
      this.selectedMode == 'uploadFile' &&
      mobileNumberArray?.length > this.maxMobileNumbers
    ) {
      let message = this.translate.instant('messages.maxMobileNumbers', {
        maxMobileNumbers: this.numberSeparatorPipe.transform(
          this.maxMobileNumbers
        ),
      });

      this.dialogService.openDialog({
        title: 'common.error',
        message: message,
        status: DialogStatus.error,
      });
      return mobileNumberArray.splice(0, this.maxMobileNumbers);
    }
    //manual mode
    else if (
      this.selectedMode == 'manual' &&
      mobileNumberArray?.length > this.maxMobileNumbersInManualMode
    ) {
      let message = this.translate.instant(
        'messages.maxMobileNumbersInManualMode',
        {
          maxMobileNumbersInManualMode: this.numberSeparatorPipe.transform(
            this.maxMobileNumbersInManualMode
          ),
        }
      );

      this.dialogService.openDialog({
        title: 'common.error',
        message: message,
        status: DialogStatus.error,
      });
      return mobileNumberArray.splice(0, this.maxMobileNumbersInManualMode);
    } else if (
      this.selectedMode == 'clipboard' &&
      mobileNumberArray?.length > this.maxMobileNumbersInClipBoardMode
    ) {
      let message = this.translate.instant(
        'messages.maxMobileNumbersInClipBoardMode',
        {
          maxMobileNumbersInClipBoardMode: this.numberSeparatorPipe.transform(
            this.maxMobileNumbersInClipBoardMode
          ),
        }
      );

      this.dialogService.openDialog({
        title: 'common.error',
        message: message,
        status: DialogStatus.error,
      });
      return mobileNumberArray.splice(0, this.maxMobileNumbersInClipBoardMode);
    }
    return mobileNumberArray;
  }

  //#endregion

  //#region Cleaner And Copy

  clearWrongMobileNumbers(manuallySelectMode?) {
    if (this.selectedMode == 'manual') {
      this.wrongMobileNumbersInManualMode = '';
      this.wrongMobileNumbersCountInManualMode = 0;
      this.wrongMobileNumbersFileInManualMode = '';
    } else if (
      (this.selectedMode == 'uploadFile' && !manuallySelectMode) ||
      manuallySelectMode == 'uploadFile'
    ) {
      this.wrongMobileNumbersInUploadFileMode = '';
      this.wrongMobileNumbersCountInUploadFileMode = 0;
    } else if (
      (this.selectedMode == 'clipboard' && !manuallySelectMode) ||
      manuallySelectMode == 'clipboard'
    ) {
      this.wrongMobileNumbersInClipboardMode = '';
      this.wrongMobileNumbersCountInClipboardMode = 0;
      this.wrongMobileNumbersFileInClipboardMode = '';
    }
  }

  clearCorrectMobileNumbers(manuallySelectMode?) {
    if (this.selectedMode == 'manual') {
      this.mobileNumbersInManualMode = '';
      this.mobileNumbersFileInManualMode = '';
      this.duplicatedMobileNumbersCountInManualMode = 0;
      this.mobileNumbersCountInManualMode = 0;
    } else if (
      (this.selectedMode == 'uploadFile' && !manuallySelectMode) ||
      manuallySelectMode == 'uploadFile'
    ) {
      this.mobileNumbersInUploadFileMode = '';
      this.mobileNumbersCountInUploadFileMode = 0;
    } else if (
      (this.selectedMode == 'clipboard' && !manuallySelectMode) ||
      manuallySelectMode == 'clipboard'
    ) {
      this.mobileNumbersInClipboardMode = '';
      this.mobileNumbersCountInClipboardMode = 0;
      this.mobileNumbersFileInClipboardMode = '';
      this.duplicatedMobileNumbersCountInClipboardMode = 0;
    }
    this.emit();
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }

  getDataFromClipboard() {
    navigator.clipboard
      .readText()
      .then((text) => {
        this.checkPastedText(null, text);
      })
      .catch((err) => {});
  }

  //#endregion

  //#region Set Output Model
  setFinalModel(data: any, appendToPrevious?: boolean) {
    let result: string[] = [];

    //پاک کردن خروجی
    if (!data) {
      if (!appendToPrevious) {
        if (this.selectedMode == 'manual') this.mobileNumbersInManualMode = '';
        else if (this.selectedMode == 'uploadFile')
          this.mobileNumbersInUploadFileMode = '';
        else if (this.selectedMode == 'clipboard')
          this.mobileNumbersInClipboardMode = '';
      }
      this.emit();
      return;
    }

    if (typeof data === 'string') {
      result = data.splitByNewLine();

      if (this.selectedMode == 'manual')
        this.mobileNumbersInManualMode = result.join(',');
      else if (this.selectedMode == 'uploadFile')
        this.mobileNumbersInUploadFileMode = result.join(',');
      else if (this.selectedMode == 'clipboard')
        this.mobileNumbersInClipboardMode = result.join(',');

      this.emit();
    } else result = data;

    // appendToPrevious
    if (appendToPrevious) {
      if (this.selectedMode == 'manual')
        this.mobileNumbersInManualMode += result.join(',') + ',';
      else if (this.selectedMode == 'uploadFile')
        this.mobileNumbersInUploadFileMode += result.join(',') + ',';
      else if (this.selectedMode == 'clipboard')
        this.mobileNumbersInClipboardMode += result.join(',') + ',';

      this.emit();
      return;
    }

    if (this.selectedMode == 'manual')
      this.mobileNumbersInManualMode = result.join(',') + ',';
    else if (this.selectedMode == 'uploadFile')
      this.mobileNumbersInUploadFileMode = result.join(',') + ',';
    else if (this.selectedMode == 'clipboard')
      this.mobileNumbersInClipboardMode = result.join(',') + ',';

    this.emit();
  }
  //#endregion

  //#region Text Compression

  compressionString(data: string): string {
    if (!data) return '';
    const compressed = compressToEncodedURIComponent(data);

    return compressed;
  }

  //#endregion

  emit() {
    this.mobileNumbers =
      this.mobileNumbersInManualMode +
      this.mobileNumbersInClipboardMode +
      this.mobileNumbersInUploadFileMode;

    this.mobileNumbers = this.mobileNumbers.replace(/\n/g, ',');

    let correctMobileNumberArray: string[] = this.mobileNumbers.split(',');

    //حذف تکراری ها
    correctMobileNumberArray =
      this.mobileNumbersService.removeDuplicateMobileNumberFromArray(
        correctMobileNumberArray
      );
    this.mobileNumbers = correctMobileNumberArray?.join(',');

    if (this.isCompressionMobiles)
      this.outputModel.emit(this.compressionString(this.mobileNumbers));
    else this.outputModel.emit(this.mobileNumbers);
  }

  onChangeMode(mode: AppMobilesAnalysisSelectedMode) {
    const beforeSelectedMode = this.selectedMode;
    this.selectedMode = mode;

    if (
      (mode == 'clipboard' && this.mobileNumbersCountInUploadFileMode > 0) ||
      (mode == 'uploadFile' && this.mobileNumbersCountInClipboardMode > 0)
    ) {
      //check

      let modeWithData =
        this.mobileNumbersCountInClipboardMode > 0 ? 'clipboard' : 'uploadFile';
      let modeWithDataTitle =
        this.mobileNumbersCountInClipboardMode > 0
          ? this.translate.instant('common.clipBoard')
          : this.translate.instant('common.fileUpload');
      let modeTitle =
        this.selectedMode == 'clipboard'
          ? this.translate.instant('common.clipBoard')
          : this.translate.instant('common.fileUpload');
      let dialogResult = this.dialogService.confirmDialog({
        title: this.translate.instant('common.warning'),
        content: this.translate.instant(
          'messages.clipBoardAndFileUploadWarning',
          { modeWithDataTitle, modeTitle }
        ),
        isWarning: true,
        wordBreak: false,
        contentToInnerHtml: true,
        confirmBtnColor: 'btn-danger',
      });
      dialogResult.afterClosed().subscribe((result) => {
        if (result)
          //yes
          this.resetModelWhenMoveBetweenMode(modeWithData);
        //no
        else this.selectedMode = beforeSelectedMode;
      });
    }

    this.outputSelectedMode.emit(this.selectedMode);
  }

  resetModelWhenMoveBetweenMode(mode) {
    this.clearCorrectMobileNumbers(mode);
    this.clearWrongMobileNumbers(mode);
    this.resetInputFile();
  }
}
